var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:_vm.classes},[_c('a',{attrs:{"href":_vm.href,"target":_vm.target,"title":_vm.label}},[_c('img',{staticClass:"side-menu-app-icon",attrs:{"src":_vm.icon,"alt":_vm.label}}),_vm._v(" "),_c('span',{staticClass:"side-menu-app-text",domProps:{"textContent":_vm._s(_vm.label)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }